import React, { useState, useContext, useRef } from 'react';
import { useIntl } from 'react-intl';

import { ThemeContext } from 'styled-components';

import CardVector from '../../../components/CardVector';
import CheckForm from './components/CheckForm';
import { fetchBalance } from '../../../services';
import Transactions from './components/Transactions';
import {
  CardContainer,
  Container,
  Description,
  Seperator,
  Subtitle,
  Title,
  Wrapper,
} from './components/CheckForm/styles';

export default () => {
  const intl = useIntl();
  const page = 'balance';
  const theme = useContext(ThemeContext);
  const [prn, setprn] = useState('');
  const [isprn, setisprn] = useState(false);
  const [error, setError] = useState(null);
  const recaptchaRef = useRef(null);
  const [token, setToken] = useState(null);
  const [loading, setloading] = useState(false);
  const [balanceInfo, setbalanceInfo] = useState(null);
  const isGalileo = theme.brand.processor === 'galileo';
  const isValid = () => prn && token;

  const handleChange = newToken => {
    setToken(newToken);
    setError(null);
  };

  const handleExpire = () => {
    setToken(null);
  };

  const resetCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setToken(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setloading(true);
    try {
      const res = await fetchBalance(prn);
      const json = await res.json();
      if (json.error) throw new Error(json.error.message);
      setbalanceInfo(json.data);
      setisprn(true);
      setToken(null);
      setError(null);
      resetCaptcha();
    } catch (error) {
      setError(error.message || true);
      resetCaptcha();
    }
    setloading(false);
  };
  // TODO: Need to get correct wording for this page from Operations
  return (
    <div page={page}>
      {!isprn && (
        <Wrapper
          className={`${
            Object.values(theme.brand.cbc_footer || {}).filter(l => l.url)
              .length > 0
              ? 'hasfooterlinks'
              : ''
          }`}
        >
          <div>
            <Title>{intl.messages[`${page}-title`]}</Title>
            <Subtitle>
              {
                intl.messages[
                  `${page}-${isGalileo ? 'subtitlegalileo' : 'subtitle'}`
                ]
              }
            </Subtitle>
          </div>
          <Container>
            <CardContainer>
              <div>
                <CardVector color={theme.brand.primary} isGalileo={isGalileo} />
              </div>
              <Seperator />
              <CheckForm
                page={page}
                setisprn={setisprn}
                locale={theme.locale}
                handleChange={handleChange}
                handleExpire={handleExpire}
                handleSubmit={handleSubmit}
                isValid={isValid}
                loading={loading}
                error={error}
                recaptchaRef={recaptchaRef}
                prn={prn}
                setprn={setprn}
                isGalileo={isGalileo}
              />
            </CardContainer>
          </Container>
          <Description>
            {intl.messages[`${page}-privacydescription`]}
          </Description>
        </Wrapper>
      )}
      {isprn && (
        <Transactions
          page={page}
          prn={prn}
          setprn={setprn}
          setisprn={setisprn}
          locale={theme.locale}
          balanceInfo={balanceInfo}
        />
      )}
    </div>
  );
};
